import React, { Component } from 'react';  
import './Footer.css';  
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie'; 
import logoWhite from './img/Livetopic-1.svg';
import logoDark from './img/Livetopic.svg';
import facebook from './img/facebook.svg';
import twitter from './img/twiiter.svg';
import instagram from './img/instagram.svg';
import linkedin from './img/linkedin-white.png';
import medium from './img/medium-white.png';
import linkedinColor from './img/linkedin.png';
import medliveColor from './img/medlive-color.png';
import medliveWhite from './img/medlive-white.png';
import mediumColor from './img/medium.png';
import facebookColor from './img/facebook-color.svg';
import twitterColor from './img/twitter-color.svg';
import linkedinColorAlt from './img/linkedin.png';
import mediumColorAlt from './img/medium.png';
import instagramColor from './img/instagram-color.svg';
import facebookColorAlt from './img/facebook-color-alt.png';
import twitterColorAlt from './img/twiiter-color-alt.png';
import instagramColorAlt from './img/instagram-color-alt.png';
import { Container, Form, Modal, Button, Nav, Navbar, Row, Col } from 'react-bootstrap';  
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'; 
import rectangle from './img/Rectangle 1.png';
import rectangleMobile from './img/Rectangle-mobile.png';
import iceCream from './img/helado.webp'; 
import spain from './img/neotec.png'; 
import europe from './img/union-europea.png'; 
import enisa from './img/enisa.png'; 
import reacciona from '../Header/img/Cartel_Empresas-2022_.jpeg'
import { LazyLoadImage } from 'react-lazy-load-image-component';

class FooterHome extends Component {

  constructor (props) {
    super(props);
    let url  = window.location.href;
    let lang;
    if(url.search('/en') !== -1){
      lang='en';
    }else{
      lang='es';
    }
    var listaPalabras = JSON.stringify(require('../../translate/'+lang+'.json'));
    var wordList = JSON.parse(listaPalabras);
    if(lang === "es"){
      lang='';
    }else{
      lang=lang+'/';
    }
    this.state = {
      lang: lang,
      wordList: wordList.app, 
      wordListUrl : wordList.url,
      modalContact : false,
      show : false, 
      showImage : false, 
      setShow : false
    }; 
    this.handleClose =  this.handleClose.bind(this)
    this.handleShow =  this.handleShow.bind(this)
    this.handleShowImage =  this.handleShowImage.bind(this)
    this.goForm=this.goForm.bind(this)
  }

  handleClose() { 
    this.setState(prevState => ({
        setShow: !prevState.setShow,
        show: !prevState.show
    }));  
  }
  handleShow() { 
      this.setState(prevState => ({
          setShow: !prevState.setShow,
          show: !prevState.show
      }));  
  }

  handleShowImage() { 
    this.setState(prevState => ({
        showImage: !prevState.showImage
    }));  
}
   
  goForm() { 
    // ABRE PÁGINA SINIESTRO O PASA PRIMERO POR ACCESS
    Cookies.set('sinister', 1, { expires: 1, path: '/'  });
    // COMPROBAMOS SI TIENE LA COOKIE DE LOGIN, SI TIENE LA SESIÓN CERRADA, LO REDIRIGE A Access
    var user = Cookies.get('user');
    if (user === undefined) { 
        this.props.history.push('/' + this.state.lang+""+this.state.wordListUrl.access);
    } else { 
        this.props.history.push('/' + this.state.lang+""+this.state.wordListUrl.profileNotify); 
    }
  }
 
  render() {
    const { wordList, lang, show, wordListUrl, showImage } = this.state;
    const { type } = this.props;
    
    if(type==="dark") {
      return ( 
        <div id="footer-home"> 
            <div className="pre-footer" id="box-3" style={{position:"relative"}}>
                
                <LazyLoadImage src={rectangle} className="rectangle"/>
                <LazyLoadImage src={iceCream} className="ice-cream"/>
                <LazyLoadImage src={rectangleMobile} className="rectangle-mobile"/>
                <Container>
                    <Row className="box-3">
                        <Col  md={12}  lg={6} className="message-ice-cream">
                            <h3>{wordList.tacha}</h3> 
                                <Link to={"/"+lang+""+wordListUrl.howWork}><Button size="lg" className="border-button">{wordList.saber}  </Button></Link>
                                {/*<Link to={"/"+lang+""+wordListUrl.recommender1}><Button size="lg" className="box-button margin-left-15">{wordList.reservar}  </Button></Link>*/}
                                <a href="https://www.iatisegurosvida.com/" target="_blank" rel="noopener noreferrer"><Button size="lg" className="box-button margin-left-15">{wordList.reservar}  </Button></a>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="pos-footer"> 
                <Navbar variant="light">
                    <Container>
                      <Row className="w100">
                      <Col xs={12} lg={6} className="logo-footer">
                        <Navbar.Brand><Link to={"/"+lang}><LazyLoadImage src={logoWhite} style={{width:"230px"}} className="margin-bottom" alt={wordList.logo}/></Link></Navbar.Brand>
                        <Nav className="navbar-nav"> <a href={"mailto:"+wordList.email} target="_blank"  className="nav-link margin-bottom rounded-color font-m">{wordList.email}</a></Nav>
                        <p>{wordList.calle} <br/>{wordList.calle1}</p>
                        <p></p>

                      </Col>
                      <Col xs={12} lg={6}>
                          <Row>
                            <Col xs={6}>
                              <ul className="list-footer">
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.recommender1} className="nav-link font-l">{wordList.recomendador}</Link></li>
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.howWork} className="nav-link font-l">{wordList.porque}</Link></li>
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.product} className="nav-link font-l">{wordList.producto}</Link></li>
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.faqs} className="nav-link font-l">{wordList.preguntas}</Link></li>
                              </ul>
                            </Col>
                            <Col xs={6}>
                              <ul className="list-footer">
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.about} className="nav-link font-l">{wordList.nosotros}</Link></li>
                                 {/* <li><Link to={'/'+this.state.lang+""+wordListUrl.recomendar} className="nav-link font-l">{wordList.blog}</Link></li>*/}
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.contact} className="nav-link font-l">{wordList.contacto}</Link></li>
                                {/*  <li><a onClick={this.goForm} className="nav-link font-l">{wordList.notificar}</a></li> */}
                              </ul>
                            </Col>
                          </Row> 
                      </Col>
                      <Col md={12} lg={8}>
                        <Row className="box-info">
                          <Col xs={12}  md={8}  className="insure-text">
                              {wordList.tacha}
                          </Col>
                          <Col xs={12}  md={4} >
                              <Link to={"/"+lang+""+wordListUrl.recommender1}><Button size="lg" className="insure">{wordList.asegurar}  </Button></Link>
                          </Col>
                        </Row>  
                      </Col>
                      <Col md={12} className="medlive">
                        {/*<LazyLoadImage src={medliveWhite} style={{width:"150px", height:"59px", padding:"0px"}} alt={wordList.medlive}/>*/} <span className="medliveCopyright">{wordList.medliveCopyright} <br/> {wordList.medliveCopyright2}</span>
                      </Col>
                      <Col  md={12} lg={12}> 
                        <Row className="box-copyright">
                          <Col md={12} lg={4} className="social-media-mobile">
                              <a href="https://livetopic.medium.com" target="_blank" className="box-copyright-right"><LazyLoadImage src={medium} style={{width:"17px"}} className="margin-bottom" alt={wordList.medium}/></a>
                              <a href="https://es.linkedin.com/company/livetopic" target="_blank" className="box-copyright-right"><LazyLoadImage src={linkedin} style={{width:"15px"}} className="margin-bottom" alt={wordList.linkedin}/></a>
                              <a href="https://twitter.com/livetopic17" target="_blank" className="box-copyright-right"><LazyLoadImage src={twitter} style={{width:"17px"}} className="margin-bottom" alt={wordList.twitter}/></a>
                              <a href="https://www.instagram.com/livetopic17/?hl=es" target="_blank" className="box-copyright-right"><LazyLoadImage src={instagram} style={{width:"15px"}} className="margin-bottom" alt={wordList.instagram}/></a>
                              <a href="https://es-es.facebook.com/livetopic17/" target="_blank" className="box-copyright-right"><LazyLoadImage src={facebook} style={{width:"15px"}} className="margin-bottom" alt={wordList.facebook}/></a>
                          </Col>
                          <Col md={12} lg={8}>
                              {/*<p>{wordList.copyright}</p>
                              <Link to={"/"+lang+""+wordListUrl.terms} className="link-footer">{wordList.condiciones} </Link>
                              <Link to={"/"+lang+""+wordListUrl.privacy} className="link-footer">{wordList.privacidad}</Link>
                              <Link to={"/"+lang+""+wordListUrl.cookies} className="link-footer">{wordList.cokkies} </Link>
                              <Link to={"/"+lang+""+wordListUrl.medlive} className="link-footer">{wordList.medliveDigital} </Link>*/}
        
                              <p>{wordList.copyright}</p>
                              <Link to="#" className="link-footer">{wordList.condiciones}</Link>
                              <Link to="#" className="link-footer">{wordList.privacidad}</Link>
                              <Link to="#" className="link-footer">{wordList.cokkies}</Link>
                          </Col>
                          <Col md={12} lg={4} className="social-media">
                              <a href="https://livetopic.medium.com" target="_blank" className="box-copyright-right"><LazyLoadImage src={medium} style={{width:"17px"}} className="margin-bottom" alt={wordList.medium}/></a>
                              <a href="https://es.linkedin.com/company/livetopic" target="_blank" className="box-copyright-right"><LazyLoadImage src={linkedin} style={{width:"15px"}} className="margin-bottom" alt={wordList.linkedin}/></a>
                              <a href="https://twitter.com/livetopic17" target="_blank" className="box-copyright-right"><LazyLoadImage src={twitter} style={{width:"17px"}} className="margin-bottom" alt={wordList.twitter}/></a>
                              <a href="https://www.instagram.com/livetopic17/?hl=es" target="_blank" className="box-copyright-right"><LazyLoadImage src={instagram} style={{width:"15px"}} className="margin-bottom" alt={wordList.instagram}/></a>
                              <a href="https://es-es.facebook.com/livetopic17/" target="_blank" className="box-copyright-right"><LazyLoadImage src={facebook} style={{width:"15px"}} className="margin-bottom" alt={wordList.facebook}/></a>
                          </Col>
                        </Row>
                      </Col>
                      </Row>
                    </Container>
                </Navbar>
            </div> 
            

            <Modal show={show} size="lg" onHide={this.handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header className="close-modal" onClick={this.handleClose}> 
                    <FontAwesomeIcon  className="icon-size-left" icon={faTimes} />
                </Modal.Header>
                <Modal.Body>
                    <h2 className="title-modal">{wordList.titleModalAyuda}</h2> 
                    <p className="sub-title-modal">{wordList.subTitleModalAyuda}</p>  
                    <div className="form-number">
                    <Form.Control type="number" placeholder="612 345 678"/>
                    </div>
                    <div style={{textAlign:"center"}}>
                    <Button size="lg" className="bottom-call-popup">{wordList.botonLlamadme} </Button>
                    </div>
                    
                </Modal.Body> 
            </Modal> 
        </div>
      );
    } else if(type=="light") {
      return ( 
        <div className="footer-home-white"> 
            <div> 
                <Navbar variant="light">
                    <Container>
                      <Row className="w100">
                      <Col xs={12} lg={6} className="logo-footer">
                         <Navbar.Brand><Link to={"/"+lang}><LazyLoadImage src={logoDark} style={{width:"230px"}} className="margin-bottom" alt={wordList.logo}/></Link></Navbar.Brand>
                        <Nav className="navbar-nav"><a href={"mailto:"+wordList.email} target="_blank"  className="nav-link margin-bottom rounded-color-white font-m">{wordList.email}</a></Nav>
                        <p>{wordList.calle} <br/>{wordList.calle1}</p>
                        <p></p>
  
                      </Col>
                      <Col xs={12} lg={6}>
                          <Row>
                            <Col xs={6}>
                              <ul className="list-footer-dark">
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.recommender1} className="nav-link font-l">{wordList.recomendador}</Link></li>
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.howWork} className="nav-link font-l">{wordList.porque}</Link></li>
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.product} className="nav-link font-l">{wordList.producto}</Link></li>
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.faqs} className="nav-link font-l">{wordList.preguntas}</Link></li>
                              </ul>
                            </Col>
                            <Col xs={6}>
                              <ul className="list-footer-dark">
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.about} className="nav-link font-l">{wordList.nosotros}</Link></li>
                                 {/* <li><Link to={'/'+this.state.lang+""+wordListUrl.recomendar} className="nav-link font-l">{wordList.blog}</Link></li>*/}
                                <li><Link to={'/'+this.state.lang+""+wordListUrl.contact} className="nav-link font-l">{wordList.contacto}</Link></li>
                                {/*  <li><a onClick={this.goForm} className="nav-link font-l">{wordList.notificar}</a></li> */}
                              </ul>
                            </Col>
                          </Row> 
                      </Col>
                      <Col md={12} lg={8}>
                        <Row className="box-info-white">
                          <Col  xs={12}  md={8} className="insure-text-dark">
                              {wordList.tacha}
                          </Col>
                          <Col xs={12} md={4}>
                              <Link to={"/"+lang+""+wordListUrl.recommender1}><Button size="lg" className="insure">{wordList.asegurar}  </Button></Link>
                          </Col>
                         </Row>  
                      </Col>
                      <Col md={12} className="medlive">
                        {/*<LazyLoadImage src={medliveColor} style={{width:"150px", height:"77px"}} alt={wordList.medlive}/>*/} <span className="medliveCopyright">{wordList.medliveCopyright} <br/> {wordList.medliveCopyright2}</span>
                      </Col>
                      <Col md={12} lg={12} style={{marginBottom:"40px"}}> 
                        <Row className="box-copyright-white">
                          <Col md={12} lg={4} className="social-media-mobile">
                              <a href="https://livetopic.medium.com" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={mediumColor} style={{width:"17px"}} className="margin-bottom" alt={wordList.medium}/></a>
                              <a href="https://es.linkedin.com/company/livetopic" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={linkedinColor} style={{width:"15px"}} className="margin-bottom" alt={wordList.linkedin}/></a>
                              <a href="https://twitter.com/livetopic17" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={twitterColor} style={{width:"17px"}} className="margin-bottom" alt={wordList.twitter}/></a>
                              <a href="https://www.instagram.com/livetopic17/?hl=es" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={instagramColor} style={{width:"15px"}} className="margin-bottom" alt={wordList.instagram}/></a>
                              <a href="https://es-es.facebook.com/livetopic17/" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={facebookColor} style={{width:"15px"}} className="margin-bottom" alt={wordList.facebook}/></a>
                          </Col>
                          <Col md={12} lg={8}>
                              {/*<p>{wordList.copyright}</p>
                              <Link to={"/"+lang+""+wordListUrl.terms} className="link-footer">{wordList.condiciones} </Link>
                              <Link to={"/"+lang+""+wordListUrl.privacy} className="link-footer">{wordList.privacidad}</Link>
                              <Link to={"/"+lang+""+wordListUrl.cookies} className="link-footer">{wordList.cokkies} </Link>
                              <Link to={"/"+lang+""+wordListUrl.medlive} className="link-footer">{wordList.medliveDigital} </Link>*/}
        
                              <p>{wordList.copyright}</p>
                              <Link to="#" className="link-footer">{wordList.condiciones}</Link>
                              <Link to="#" className="link-footer">{wordList.privacidad}</Link>
                              <Link to="#" className="link-footer">{wordList.cokkies}</Link>
                          </Col>
                          <Col md={12} lg={4} className="social-media">
                              <a href="https://livetopic.medium.com" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={mediumColor} style={{width:"17px"}} className="margin-bottom" alt={wordList.medium}/></a>
                              <a href="https://es.linkedin.com/company/livetopic" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={linkedinColor} style={{width:"15px"}} className="margin-bottom" alt={wordList.linkedin}/></a>
                              <a href="https://twitter.com/livetopic17" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={twitterColor} style={{width:"17px"}} className="margin-bottom" alt={wordList.twitter}/></a>
                              <a href="https://www.instagram.com/livetopic17/?hl=es" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={instagramColor} style={{width:"15px"}} className="margin-bottom" alt={wordList.instagram}/></a>
                              <a href="https://es-es.facebook.com/livetopic17/" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={facebookColor} style={{width:"15px"}} className="margin-bottom" alt={wordList.facebook}/></a>
                          </Col>
                        </Row>
                      </Col>
                      <div  className="financial-1" style={{marginBottom:"20px"}}> 
                        <div className="text-center"> 
                        <LazyLoadImage src={enisa} style={{maxWidth:"100%"}}/></div>
                      </div>
                      <div className="financial-2" style={{marginBottom:"20px"}}> 
                      <div className="text-center"> {wordList.proyecto}<br/><br/> 
                        <LazyLoadImage src={spain} style={{maxWidth:"100%"}}/></div>
                      </div>
                      <div className="financial-2" style={{marginBottom:"20px"}}> 
                        <div className="text-center" onClick={this.handleShowImage} >{wordList.fondoEuropeo} <br/> <br/>
                        <LazyLoadImage src={europe} style={{maxWidth:"100%"}}/></div>
                      </div>
                      
                      
                      </Row>
                    </Container>
                </Navbar>
            </div> 

            <Modal show={showImage}  size="xl" className="modal-popup reacciona"  onHide={this.handleShowImage}>
              <Modal.Header closeButton/>
              <Modal.Body > <img src={reacciona} width="700" heigh="700" alt="REACCIONA"/></Modal.Body>
            </Modal>
  
            <Modal show={show} size="lg" onHide={this.handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header className="close-modal" onClick={this.handleClose}> 
                    <FontAwesomeIcon  className="icon-size-left" icon={faTimes} />
                </Modal.Header>
                <Modal.Body>
                    <h2 className="title-modal">{wordList.titleModalAyuda}</h2> 
                    <p className="sub-title-modal">{wordList.subTitleModalAyuda}</p>  
                    <div className="form-number">
                    <Form.Control type="number" placeholder="612 345 678"/>
                    </div>
                    <div style={{textAlign:"center"}}>
                    <Button size="lg" className="bottom-call-popup">{wordList.botonLlamadme} </Button>
                    </div>
                    
                </Modal.Body> 
            </Modal> 
        </div>
      );
    } else if(type=="recommender") {

      return ( 
      <div id="footer"> 
          <Container> 
                <Row md={12} className="medlive">
                  {/*<LazyLoadImage src={medliveWhite} style={{width:"150px", height:"59px", padding:"0px"}} alt={wordList.medlive}/>*/}<span className="medliveCopyright" style={{marginLeft: '0px !important'}}>{wordList.medliveCopyright} <br/> {wordList.medliveCopyright2}</span>
                </Row>
                <Row className="box-copyright">
                    <Col md={12} lg={4} className="social-media-mobile">
                        <a href="https://livetopic.medium.com" target="_blank" className="box-copyright-right"><LazyLoadImage src={medium} style={{width:"17px"}} className="margin-bottom" alt={wordList.medium}/></a>
                        <a href="https://es.linkedin.com/company/livetopic" target="_blank" className="box-copyright-right"><LazyLoadImage src={linkedin} style={{width:"15px"}} className="margin-bottom" alt={wordList.linkedin}/></a>
                        <a href="https://twitter.com/livetopic17" target="_blank" className="box-copyright-right"><LazyLoadImage src={twitter} style={{width:"17px"}} className="margin-bottom" alt={wordList.twitter}/></a>
                        <a href="https://www.instagram.com/livetopic17/?hl=es" target="_blank" className="box-copyright-right"><LazyLoadImage src={instagram} style={{width:"15px"}} className="margin-bottom" alt={wordList.instagram}/></a>
                        <a href="https://es-es.facebook.com/livetopic17/" target="_blank" className="box-copyright-right"><LazyLoadImage src={facebook} style={{width:"15px"}} className="margin-bottom" alt={wordList.facebook}/></a>
                    </Col>
                    <Col md={12} lg={8}> 
                        {/*<Link to={"/"+lang+""+wordListUrl.terms} className="link-footer">{wordList.condiciones} </Link>
                        <Link to={"/"+lang+""+wordListUrl.privacy} className="link-footer">{wordList.privacidad}</Link>
                        <Link to={"/"+lang+""+wordListUrl.cookies} className="link-footer">{wordList.cokkies} </Link>
                        <Link to={"/"+lang+""+wordListUrl.medlive} className="link-footer">{wordList.medliveDigital} </Link>*/}
  
                        <Link to="#" className="link-footer">{wordList.condiciones}</Link>
                        <Link to="#" className="link-footer">{wordList.privacidad}</Link>
                        <Link to="#" className="link-footer">{wordList.cokkies}</Link>
                    </Col>
                    <Col md={12} lg={4} className="social-media">
                        <a href="https://livetopic.medium.com" target="_blank" className="box-copyright-right"><LazyLoadImage src={medium} style={{width:"17px"}} className="margin-bottom" alt={wordList.medium}/></a>
                        <a href="https://es.linkedin.com/company/livetopic" target="_blank" className="box-copyright-right"><LazyLoadImage src={linkedin} style={{width:"15px"}} className="margin-bottom" alt={wordList.linkedin}/></a>
                        <a href="https://twitter.com/livetopic17" target="_blank" className="box-copyright-right"><LazyLoadImage src={twitter} style={{width:"17px"}} className="margin-bottom" alt={wordList.twitter}/></a>
                        <a href="https://www.instagram.com/livetopic17/?hl=es" target="_blank" className="box-copyright-right"><LazyLoadImage src={instagram} style={{width:"15px"}} className="margin-bottom" alt={wordList.instagram}/></a>
                        <a href="https://es-es.facebook.com/livetopic17/" target="_blank" className="box-copyright-right"><LazyLoadImage src={facebook} style={{width:"15px"}} className="margin-bottom" alt={wordList.facebook}/></a>
                    </Col>
                  </Row>
          </Container> 
          

          <Modal show={show} size="lg" onHide={this.handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
              <Modal.Header className="close-modal" onClick={this.handleClose}> 
                  x
              </Modal.Header>
              <Modal.Body>
                  <h2 className="title-modal">{wordList.titleModalAyuda}</h2> 
                  <p className="sub-title-modal">{wordList.subTitleModalAyuda}</p>  
                  <div className="form-number">
                  <Form.Control type="number" placeholder="612 345 678"/>
                  </div>
                  <div style={{textAlign:"center"}}>
                  <Button size="lg" className="bottom-call-popup">{wordList.botonLlamadme} </Button>
                  </div>
                  
              </Modal.Body> 
          </Modal> 
      </div>
      )
    } else if(type=="profile") {

      return ( 
      <div id="footer" className="footer-profile"> 
          <Container> 
                <Row className="box-copyright">
                    <Col md={12} lg={4} className="social-media-mobile">
                        <a href="https://twitter.com/livetopic17" target="_blank" className="box-copyright-right"><LazyLoadImage src={twitterColorAlt} style={{width:"16px"}} className="margin-bottom" alt={wordList.twitter}/></a>
                        <a href="https://www.instagram.com/livetopic17/?hl=es" target="_blank" className="box-copyright-right"><LazyLoadImage src={instagramColorAlt} style={{height:"15px"}} className="margin-bottom" alt={wordList.instagram}/></a>
                        <a href="https://es-es.facebook.com/livetopic17/" target="_blank" className="box-copyright-right"><LazyLoadImage src={facebookColorAlt} style={{height:"15px"}} className="margin-bottom" alt={wordList.facebook}/></a>
                        <a href="https://es.linkedin.com/company/livetopic" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={linkedinColorAlt} style={{width:"15px"}} className="margin-bottom" alt={wordList.linkedin}/></a>
                        <a href="https://livetopic.medium.com" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={mediumColorAlt} style={{width:"15px"}} className="margin-bottom" alt={wordList.medium}/></a>
                    </Col>
                    <Col md={12} lg={8}>
                        <p><LazyLoadImage src={logoDark} style={{width:"80px", marginRight:"20px", marginTop:"-5px"}} alt={wordList.logo}/> {wordList.copyright}</p>
                        <Link to={"/"+lang+""+wordListUrl.terms} className="link-footer">{wordList.condiciones} </Link>
                        <Link to={"/"+lang+""+wordListUrl.privacy} className="link-footer">{wordList.privacidad}</Link>
                        <Link to={"/"+lang+""+wordListUrl.cookies} className="link-footer">{wordList.cokkies} </Link>
                              <Link to={"/"+lang+""+wordListUrl.medlive} className="link-footer">{wordList.medliveDigital} </Link>
                    </Col>
                    <Col md={12} lg={4} className="social-media">
                        <a href="https://twitter.com/livetopic17" target="_blank" className="box-copyright-right"><LazyLoadImage src={twitterColorAlt} style={{width:"16px"}} className="margin-bottom" alt={wordList.twitter}/></a>
                        <a href="https://www.instagram.com/livetopic17/?hl=es" target="_blank" className="box-copyright-right"><LazyLoadImage src={instagramColorAlt} style={{height:"15px"}} className="margin-bottom" alt={wordList.instagram}/></a>
                        <a href="https://es-es.facebook.com/livetopic17/" target="_blank" className="box-copyright-right"><LazyLoadImage src={facebookColorAlt} style={{height:"15px"}} className="margin-bottom" alt={wordList.facebook}/></a>
                        <a href="https://es.linkedin.com/company/livetopic" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={linkedinColorAlt} style={{width:"15px"}} className="margin-bottom" alt={wordList.linkedin}/></a>
                        <a href="https://livetopic.medium.com" target="_blank" className="box-copyright-white-right"><LazyLoadImage src={mediumColorAlt} style={{width:"15px"}} className="margin-bottom" alt={wordList.medium}/></a>
                    </Col>
                  </Row>
          </Container> 
          

          <Modal show={show} size="lg" onHide={this.handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
              <Modal.Header className="close-modal" onClick={this.handleClose}> 
                  x
              </Modal.Header>
              <Modal.Body>
                  <h2 className="title-modal">{wordList.titleModalAyuda}</h2> 
                  <p className="sub-title-modal">{wordList.subTitleModalAyuda}</p>  
                  <div className="form-number">
                  <Form.Control type="number" placeholder="612 345 678"/>
                  </div>
                  <div style={{textAlign:"center"}}>
                  <Button size="lg" className="bottom-call-popup">{wordList.botonLlamadme} </Button>
                  </div>
                  
              </Modal.Body> 
          </Modal> 
      </div>
      )
    }
  }
};

export default withRouter(FooterHome);
